import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '../buttons';

export default function RedirectLoginButton() {
  const { replace } = useRouter();
  const { t } = useTranslation();
  return (
    <Button
      style={{
        minWidth: 200,
        maxWidth: 200,
      }}
      onClick={() => replace('/login')}
    >
      {t('common:login')}
    </Button>
  );
}
